export default "__VITE_ASSET__7sFkNi7e__"